import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa3 from "../../../containers/modules/accounting/coa3";

export default function Coa3Route(props) {
  const { authUser } = props;
  return (
    <Route
      path="coa3"
      index
      element={
        <AccessControl
          name={"Coa3 List"}
          auth={authUser}
          component={() => <Coa3 />}
        />
      }
    />
  );
}
